import {useEffect} from 'react';

import routes from '../consts/routes';
import routerService from '../services/router/routerService';
import {getState} from '../state/store';
import useNavigateReplace from './useNavigateReplace';

const DEEP_LINK_ROUTES = [routes.DEV_TOOLS, routes.AI_ASSISTANT_TEST];

const useInitRoute = () => {
    const navigate = useNavigateReplace();
    const isDeepLink = DEEP_LINK_ROUTES.includes(window.location.pathname);

    useEffect(() => {
        if (isDeepLink) return;

        navigate(routes.ROOT);
    }, []);

    const handleInitRoute = () => {
        if (isDeepLink) return;

        const initRouteRules = routerService.getInitRouteRules(getState());
        const route = initRouteRules.find(({condition}) => condition())?.route || routes.CLUB_WELCOME;

        navigate(route);
    };

    return handleInitRoute;
};

export default useInitRoute;
